// src/components/layouts/PageLayout.js
import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

const PageLayout = ({ 
  title,
  children,
  showBackground = true,
  centered = false,
  maxWidth = '4xl'
}) => {
  return (
    <div className={`min-h-screen ${showBackground ? 'bg-gradient-to-br from-purple-50 to-pink-50' : ''}`}>
      {showBackground && (
        <>
          <div className="absolute top-0 right-0 -translate-y-8 translate-x-8 w-96 h-96 bg-gradient-to-br from-purple-200 to-pink-200 rounded-full filter blur-3xl opacity-30 animate-pulse" />
          <div className="absolute bottom-0 left-0 translate-y-8 -translate-x-8 w-96 h-96 bg-gradient-to-br from-purple-200 to-pink-200 rounded-full filter blur-3xl opacity-30 animate-pulse" />
        </>
      )}
      
      <div className={`max-w-${maxWidth} mx-auto px-4 py-8 relative ${centered ? 'flex flex-col items-center' : ''}`}>
        {title && (
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-8 text-center"
          >
            {title}
          </motion.h1>
        )}
        {children}
      </div>
    </div>
  );
};

PageLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  showBackground: PropTypes.bool,
  centered: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl'])
};

export default PageLayout;